import { ABOUT } from "../data/siteData";
import { Heart, Eye, Target } from "lucide-react";

export const About = () => {
  return (
    <section id="sobre-nosotros" className="section-padding bg-beige-50" data-testid="about-section">
      <div className="container-aura grid lg:grid-cols-12 gap-16 items-center">
        {/* Image side */}
        <div className="lg:col-span-5 relative">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border border-gold/30 rounded-[2rem]" aria-hidden="true"></div>
            <div className="relative rounded-[2rem] overflow-hidden">
              <img
                src={ABOUT.director.photo}
                alt={ABOUT.director.name}
                className="w-full h-[600px] object-cover"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-5 shadow-xl border border-beige-200 max-w-[220px]">
              <div className="text-xs tracking-luxe uppercase text-gold mb-1">Directora</div>
              <div className="font-serif text-xl text-ink leading-tight">{ABOUT.director.name}</div>
              <div className="text-xs text-ink-soft mt-1">{ABOUT.director.role}</div>
            </div>
          </div>
        </div>

        {/* Text side */}
        <div className="lg:col-span-7">
          <div className="text-xs tracking-luxe uppercase text-gold mb-4">Sobre Nosotros</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-tight mb-6">
            Un refugio para tu <span className="italic text-gold">belleza</span> y bienestar
          </h2>
          <div className="gold-divider mb-8"></div>

          {ABOUT.paragraphs.map((p, i) => (
            <p key={i} className="text-base md:text-lg text-ink-soft leading-relaxed mb-5 font-light">
              {p}
            </p>
          ))}

          <p className="text-base md:text-lg text-ink-soft leading-relaxed mb-10 font-light">
            {ABOUT.director.bio}
          </p>

          <div className="grid sm:grid-cols-2 gap-6">
            <div className="p-6 bg-white rounded-2xl border border-beige-200">
              <div className="w-10 h-10 rounded-full bg-gold-50 flex items-center justify-center mb-3">
                <Target size={18} className="text-gold" />
              </div>
              <div className="font-serif text-lg text-ink mb-2">Misión</div>
              <p className="text-sm text-ink-soft leading-relaxed font-light">{ABOUT.mision}</p>
            </div>
            <div className="p-6 bg-white rounded-2xl border border-beige-200">
              <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center mb-3">
                <Eye size={18} className="text-gold-600" />
              </div>
              <div className="font-serif text-lg text-ink mb-2">Visión</div>
              <p className="text-sm text-ink-soft leading-relaxed font-light">{ABOUT.vision}</p>
            </div>
          </div>

          <div className="mt-8 flex items-center gap-3 text-ink-soft">
            <Heart size={16} className="text-gold" />
            <span className="text-sm italic">Cuidamos de ti como si fueras parte de la familia.</span>
          </div>
        </div>
      </div>
    </section>
  );
};
